<template>
  <div class="perfil">
    <TrocarSenha :estado="trocaSenhaComp" :fechar.sync="trocaSenha" />
    <button :class="estadoDoPerfilComp ? 'avatar ativo' : 'avatar'" @click="estadoDoPerfil()">
      <img src="@/assets/imgs/icone_usuario.svg" />
      <div class="seta"></div>
    </button>
    <div v-if="estadoDoPerfilComp" class="menu">
      <div class="header">{{ user.nome | shortName(18) }}</div>
      <div class="opcoes">
        <button>
          <div class="linha" @click="mudarEstadoListaUfs()">
            <p>
              UF: &nbsp;
              <strong>{{ ufAtiva + ' (' + user.funcao + ')' }}</strong>
            </p>
            <img
              src="@/assets/imgs/icone_topo_branco.png"
              :style="listaUfAbertaComp ? 'transform: rotate(0deg)' : ''"
            />
          </div>
          <ul v-if="listaUfAbertaComp">
            <li v-for="(uf, indice) in user.uf" :key="indice">
              <a
                href="javascript:void(0)"
                :class="uf == ufAtiva ? 'ufativo' : ''"
                @click="changeUF(uf)"
              >{{ uf }}</a>
            </li>
          </ul>
        </button>
        <AlterarVisao/>
        <button @click="estadoTrocaSenha()">
          <div class="linha">
            <p>Trocar Senha</p>
          </div>
        </button>
      </div>
      <button class="sair" @click="userLogout">Sair da conta</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TrocarSenha from '@/components/layout/header/TrocarSenha.vue';
import AlterarVisao from '@/components/layout/header/AlterarVisao.vue';

export default {
  name: 'Perfil',
  components: {
    TrocarSenha,
    AlterarVisao
  },

  data() {
    return {
      redirect: `${window.location.protocol}//${window.location.host}/_sys/portal-login/`,
      perfilAtivo: false,
      listaUfAberta: false,
      trocaSenha: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
      ufAtiva: 'user/ufState',
    }),
    listaUfAbertaComp() {
      return this.listaUfAberta;
    },
    estadoDoPerfilComp() {
      return this.perfilAtivo;
    },
    trocaSenhaComp() {
      return this.trocaSenha;
    },
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      changeUF: 'user/changeUF',
    }),
    async userLogout() {
      await this.logout();
      window.location.href = this.redirect;
    },
    mudarEstadoListaUfs() {
      this.listaUfAberta = !this.listaUfAberta;
    },
    estadoDoPerfil() {
      this.perfilAtivo = !this.perfilAtivo;
      this.listaUfAberta = false;
    },
    estadoTrocaSenha() {
      this.trocaSenha = !this.trocaSenha;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

button {
  cursor: pointer;
  user-select: none;
  background: transparent;
  border: 0px;
  outline: none;
}

.perfil {
  position: relative;
  margin-left: 10px;

  & .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 34px;
    background: $cor_roxo;
    transition: all 0.2s ease-in-out;
    padding: 0px;

    & img {
      z-index: 2;
      width: 13px;
      height: 13px;
      margin-top: -2px;
    }

    & .seta {
      width: 10px;
      height: 10px;
      background: $cor_roxo;
      z-index: -1;
      position: absolute;
      border-radius: 2px;
      bottom: 0;
      left: 50%;
      margin-bottom: 10px;
      transition: all 0.2s ease-in-out;
      transform: translate(-50%, 0) rotate(45deg);
    }

    &:hover {
      background: $cor_amarelo;

      & > .seta {
        background: $cor_amarelo;
      }
    }
  }

  & .ativo {
    transform: scale(1.2);
    z-index: 1;
    background: $cor_amarelo;

    & .seta {
      margin-bottom: -1px;
      background: $cor_amarelo;
    }
  }

  & .menu {
    position: absolute;
    background: $cor_roxo;
    border-radius: 5px 5px 0 0;
    width: 200px;
    top: 45px;
    right: 0;
    padding-bottom: 50px;
    box-shadow: 0px 7px 15px rgba(black, 0.4);
    animation: abrir 0.2s 1 ease-in-out;

    & .header {
      font-size: 14px;
      font-family: 'VivoType';
      border-radius: 5px 5px 0 0;
      padding: 20px 20px 5px;
      color: $cor_roxo;
      font-weight: bold;
      font-style: italic;
      background: $cor_amarelo;
    }

    & .opcoes {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 10px 0;

      & button {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        position: relative;
        font-family: 'VivoType';
        font-size: 14px;
        line-height: 14px;
        font-weight: bold;
        border-bottom: 1px solid rgba(white, 0.08);
        padding: 15px 0px;
        width: calc(100% - 40px);

        & .linha {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          // width: calc(100% - 40px);
          // padding: 0 20px;

          & p {
            letter-spacing: 0.05em;
            color: white;
            margin: 0px;
            transition: all 0.1s ease-in-out;
          }

          & strong {
            font-family: 'VivoType';
            font-size: 13px;
            letter-spacing: 0;
            opacity: 0.5;
            font-weight: 200;
            // color: $cor_amarelo
          }

          & img {
            width: 6px;
            height: 6px;
            // transition: all .2s ease-in-out;
            transform: rotate(180deg);
          }
        }

        &:hover > .linha p {
          color: $cor_amarelo !important;
        }

        &:hover > .linha strong {
          opacity: 1;
        }

        &:hover > .linha img {
          filter: sepia(1) brightness(0.13) grayscale(0) saturate(1000)
            hue-rotate(308deg);
        }

        & ul {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          margin-left: -5px;
          padding: 10px 0 5px;

          & li {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            width: 40px;
            height: 20px;
            margin-bottom: 0px;

            & a {
              font-family: 'VivoType';
              letter-spacing: 200;
              font-weight: normal;
              line-height: 1em;
              color: rgba(white, 0.5);
              text-decoration: none;

              &:hover {
                color: white;
              }
            }

            & .ufativo {
              color: white;
              font-weight: bold;
            }

            & span {
              font-weight: 100;
              color: rgba(white, 0.15);
            }
          }
        }
      }
    }

    & .sair {
      position: absolute;
      color: rgba(white, 0.5);
      font-family: 'VivoType';
      font-weight: bold;
      padding: 0px;
      font-size: 11px;
      right: 20px;
      bottom: 15px;

      &:hover {
        color: white;
      }
    }
  }
}

@keyframes abrir {
  0% {
    opacity: 0;
    margin-top: -30px;
  }
  100% {
    opacity: 1;
    margin-top: 0px;
  }
}

@media all and (min-width: 300px) and (max-width: 1160px) {
}
</style>
